import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { InputsBindingsModel } from '../common/Models/Dialog/inputs-binding.model';
import { ValueAndDisplay } from '../common/UI-Components/helperClasses/value-and-display.class';
import { DialogRef } from '../common/Forms/Dialog-types/dialog-ref';
import { DialogModel } from '../common/Models/Dialog/dialog.model';
import { DialogService } from './dialogs.service';

@Injectable({
  providedIn: 'root'
})
export class TourDataService {
  private readonly tourTitleSubject = new BehaviorSubject<string>('');
  public tourTitle$: Observable<string> = this.tourTitleSubject.asObservable();

  constructor(private readonly router: Router, private readonly dialogService: DialogService) {}

  
  // Tour Title Methods
  setTourTitle(title: string): void {
    this.tourTitleSubject.next(title);
  }

  getTourTitle(): string {
    return this.tourTitleSubject.value;
  }

  clearTourTitle(): void {
    this.tourTitleSubject.next('');
  }

  // Clear all tour data
  clearAllTourData(): void {
    this.clearTourTitle();
  }

  refreshTour(): void {
    const inputsBinding: InputsBindingsModel = new Map<string, any>([
      ['type', 'warning'],
      ['title', 'Layer Structure Changes'],
      ['message', 'The administrator has changed the layer structure of your site. <br> Click <b>Reload</b> to continue working with the modification.'],
      ['buttonsInfo', [new ValueAndDisplay('reload', 'Reload')]]
    ]);
    const dialog: DialogRef = this.dialogService.createNotificationDialog(inputsBinding);
    dialog.onClose$().subscribe((model: DialogModel) => {
      if (model.userAction === 'reload' || model.userAction === 'cancel') {
        globalThis.location.reload();
      }
    });
  }
}
